import { render, staticRenderFns } from "./talk.vue?vue&type=template&id=3e0c2abe&scoped=true"
import script from "./talk.vue?vue&type=script&lang=js"
export * from "./talk.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/case.css?vue&type=style&index=0&id=3e0c2abe&prod&scoped=true&lang=css&external"
import style1 from "../../assets/css/doctor-detail.css?vue&type=style&index=1&id=3e0c2abe&prod&scoped=true&lang=css&external"
import style2 from "./talk.vue?vue&type=style&index=2&id=3e0c2abe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0c2abe",
  null
  
)

export default component.exports